import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

const dict = {
  en: {
    "brand.tagline": "Operations System for Roofers",
    "brand.company": "Les Entreprises C.H.C.",
    "brand.short": "C.H.C.",
    "auth.signin": "Sign in with Google",
    "auth.secure": "Secure OAuth · No password required",
    "auth.unauthorized": "This account is not authorized.",
    "nav.workspace": "Workspace",
    "nav.dashboard": "Dashboard",
    "nav.projects": "Projects",
    "nav.takeoff": "Takeoff",
    "nav.estimator": "Estimator",
    "nav.proposals": "Proposals",
    "nav.catalog": "Catalog",
    "nav.timesheet": "Timesheet",
    "nav.employees": "Employees",
    "nav.invoices": "Invoices",
    "nav.calendar": "Calendar",
    "nav.accounting": "Accounting",
    "nav.settings": "Settings",
    "common.signout": "Sign out",
    "common.new": "New",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.total": "Total",
    "common.subtotal": "Subtotal",
    "common.status": "Status",
    "common.date": "Date",
    "common.name": "Name",
    "common.phone": "Phone",
    "common.email": "Email",
    "common.address": "Address",
    "common.notes": "Notes",
    "common.amount": "Amount",
    "common.actions": "Actions",
    "common.loading": "Loading…",
    "common.viewAll": "View all",
    "common.required": "Required",
    "dashboard.title": "Control Room",
    "dashboard.sub": "Live operational view of revenue, jobs in pipeline, billable hours and what's coming up.",
    "dashboard.revenuePaid": "Revenue (paid)",
    "dashboard.outstanding": "Outstanding A/R",
    "dashboard.hoursWeek": "Hours this week",
    "dashboard.projectsKpi": "Projects",
    "dashboard.pipeline": "Pipeline",
    "dashboard.upcoming": "Upcoming",
    "dashboard.followUps": "Follow-ups",
    "dashboard.recentProjects": "Recent projects",
    "projects.title": "Project Book",
    "projects.sub": "Every job, lead and closed deal — one ledger.",
    "projects.new": "New Project",
    "projects.customer": "Customer",
    "projects.leadSource": "Lead source",
    "projects.leadValue": "Estimated value",
    "projects.followUp": "Next follow-up",
    "projects.empty": "No projects yet",
    "status.lead": "LEAD",
    "status.scheduled": "SCHEDULED",
    "status.in_progress": "IN PROGRESS",
    "status.completed": "COMPLETED",
    "status.invoiced": "INVOICED",
    "status.draft": "DRAFT",
    "status.sent": "SENT",
    "status.paid": "PAID",
    "status.accepted": "ACCEPTED",
    "status.declined": "DECLINED",
    "status.deposit_paid": "DEPOSIT PAID",
    "takeoff.title": "Measurements",
    "takeoff.sub": "Field measurements → pitched area + waste. Manual, freehand, or satellite.",
    "estimator.title": "Estimate Builder",
    "estimator.sub": "Dense line-item pricing. Materials, labor, markup, tax — total in real time.",
    "proposals.title": "Customer Proposals",
    "proposals.sub": "Branded proposals with signature + Stripe deposit. The way pros close jobs.",
    "proposals.new": "New Proposal",
    "proposals.scope": "Scope of work",
    "proposals.terms": "Terms & conditions",
    "proposals.validUntil": "Valid until",
    "proposals.deposit": "Deposit %",
    "proposals.shareLink": "Copy customer link",
    "proposals.linkCopied": "Link copied",
    "proposals.empty": "No proposals yet",
    "employees.title": "Crew",
    "employees.sub": "Your 2-5 roofers, with rates. Used everywhere — timesheets, scheduling.",
    "employees.new": "New Employee",
    "employees.role": "Role",
    "employees.rate": "Rate ($/hr)",
    "employees.active": "Active",
    "employees.empty": "No employees yet",
    "timesheet.title": "Crew Hours",
    "timesheet.sub": "Log hours per worker per job. Roll-up totals and payroll cost.",
    "timesheet.worker": "Worker",
    "timesheet.hours": "Hours",
    "timesheet.cost": "Cost",
    "timesheet.log": "Log Hours",
    "invoices.title": "Invoices",
    "invoices.sub": "Draft, send, and collect payment via Stripe. Paid invoices auto-post to the ledger.",
    "invoices.new": "New Invoice",
    "invoices.due": "Due",
    "invoices.number": "Number",
    "invoices.empty": "No invoices yet",
    "calendar.sub": "Crew schedule. Click a day to add a job.",
    "calendar.new": "New Event",
    "calendar.today": "Today",
    "accounting.title": "The Books",
    "accounting.sub": "Income, expenses, P&L. Stripe-paid invoices and deposits auto-post here.",
    "accounting.income": "Income",
    "accounting.expense": "Expenses",
    "accounting.profit": "Net Profit",
    "accounting.new": "New Entry",
    "settings.title": "Settings",
    "settings.sub": "Company branding and account preferences.",
    "settings.companyName": "Company name",
    "settings.ownerName": "Owner name",
    "settings.language": "Language",
    "files.upload": "Upload photo or PDF",
    "files.empty": "No files yet",
    "files.drop": "Drag & drop or click to upload",
  },
  fr: {
    "brand.tagline": "Système d'opérations pour couvreurs",
    "brand.company": "Les Entreprises C.H.C.",
    "brand.short": "C.H.C.",
    "auth.signin": "Se connecter avec Google",
    "auth.secure": "OAuth sécurisé · Aucun mot de passe requis",
    "auth.unauthorized": "Ce compte n'est pas autorisé.",
    "nav.workspace": "Espace de travail",
    "nav.dashboard": "Tableau de bord",
    "nav.projects": "Projets",
    "nav.takeoff": "Métré",
    "nav.estimator": "Estimateur",
    "nav.proposals": "Soumissions",
    "nav.catalog": "Catalogue",
    "nav.timesheet": "Feuille de temps",
    "nav.employees": "Employés",
    "nav.invoices": "Factures",
    "nav.calendar": "Calendrier",
    "nav.accounting": "Comptabilité",
    "nav.settings": "Paramètres",
    "common.signout": "Déconnexion",
    "common.new": "Nouveau",
    "common.save": "Enregistrer",
    "common.cancel": "Annuler",
    "common.delete": "Supprimer",
    "common.edit": "Modifier",
    "common.total": "Total",
    "common.subtotal": "Sous-total",
    "common.status": "Statut",
    "common.date": "Date",
    "common.name": "Nom",
    "common.phone": "Téléphone",
    "common.email": "Courriel",
    "common.address": "Adresse",
    "common.notes": "Notes",
    "common.amount": "Montant",
    "common.actions": "Actions",
    "common.loading": "Chargement…",
    "common.viewAll": "Voir tout",
    "common.required": "Requis",
    "dashboard.title": "Salle de contrôle",
    "dashboard.sub": "Vue d'ensemble des revenus, des projets en cours, des heures et de ce qui s'en vient.",
    "dashboard.revenuePaid": "Revenus (payés)",
    "dashboard.outstanding": "Comptes à recevoir",
    "dashboard.hoursWeek": "Heures cette semaine",
    "dashboard.projectsKpi": "Projets",
    "dashboard.pipeline": "Pipeline",
    "dashboard.upcoming": "À venir",
    "dashboard.followUps": "Relances",
    "dashboard.recentProjects": "Projets récents",
    "projects.title": "Carnet de projets",
    "projects.sub": "Tous vos contrats, soumissions et leads — un seul registre.",
    "projects.new": "Nouveau projet",
    "projects.customer": "Client",
    "projects.leadSource": "Source du lead",
    "projects.leadValue": "Valeur estimée",
    "projects.followUp": "Prochaine relance",
    "projects.empty": "Aucun projet pour l'instant",
    "status.lead": "LEAD",
    "status.scheduled": "PLANIFIÉ",
    "status.in_progress": "EN COURS",
    "status.completed": "TERMINÉ",
    "status.invoiced": "FACTURÉ",
    "status.draft": "BROUILLON",
    "status.sent": "ENVOYÉ",
    "status.paid": "PAYÉ",
    "status.accepted": "ACCEPTÉE",
    "status.declined": "REFUSÉE",
    "status.deposit_paid": "ACOMPTE PAYÉ",
    "takeoff.title": "Mesures",
    "takeoff.sub": "Mesures de terrain → surface inclinée + déchets. Manuel, à main levée ou satellite.",
    "estimator.title": "Constructeur d'estimation",
    "estimator.sub": "Prix par ligne. Matériaux, main-d'œuvre, marge, taxes — total en temps réel.",
    "proposals.title": "Soumissions clients",
    "proposals.sub": "Soumissions de marque avec signature + acompte Stripe. La façon pro de signer.",
    "proposals.new": "Nouvelle soumission",
    "proposals.scope": "Description des travaux",
    "proposals.terms": "Conditions",
    "proposals.validUntil": "Valide jusqu'au",
    "proposals.deposit": "Acompte %",
    "proposals.shareLink": "Copier le lien client",
    "proposals.linkCopied": "Lien copié",
    "proposals.empty": "Aucune soumission",
    "employees.title": "Équipe",
    "employees.sub": "Vos couvreurs et leurs taux. Utilisés partout — feuilles de temps, planning.",
    "employees.new": "Nouvel employé",
    "employees.role": "Poste",
    "employees.rate": "Taux ($/h)",
    "employees.active": "Actif",
    "employees.empty": "Aucun employé",
    "timesheet.title": "Heures d'équipe",
    "timesheet.sub": "Enregistrez les heures par travailleur et par chantier. Totaux et coûts de paie.",
    "timesheet.worker": "Travailleur",
    "timesheet.hours": "Heures",
    "timesheet.cost": "Coût",
    "timesheet.log": "Saisir heures",
    "invoices.title": "Factures",
    "invoices.sub": "Brouillon, envoi et encaissement via Stripe. Les factures payées vont au grand livre.",
    "invoices.new": "Nouvelle facture",
    "invoices.due": "Échéance",
    "invoices.number": "Numéro",
    "invoices.empty": "Aucune facture",
    "calendar.sub": "Planning d'équipe. Cliquez un jour pour ajouter un chantier.",
    "calendar.new": "Nouvel événement",
    "calendar.today": "Aujourd'hui",
    "accounting.title": "Les livres",
    "accounting.sub": "Revenus, dépenses, P&P. Les factures et acomptes Stripe sont auto-enregistrés.",
    "accounting.income": "Revenus",
    "accounting.expense": "Dépenses",
    "accounting.profit": "Profit net",
    "accounting.new": "Nouvelle entrée",
    "settings.title": "Paramètres",
    "settings.sub": "Identité de l'entreprise et préférences du compte.",
    "settings.companyName": "Nom de l'entreprise",
    "settings.ownerName": "Nom du propriétaire",
    "settings.language": "Langue",
    "files.upload": "Téléverser photo ou PDF",
    "files.empty": "Aucun fichier",
    "files.drop": "Glissez-déposez ou cliquez pour téléverser",
  },
};

const I18nCtx = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    try {
      return localStorage.getItem("chc_lang") || "en";
    } catch (e) {
      console.warn("localStorage read failed:", e);
      return "en";
    }
  });
  const setLang = useCallback((l) => {
    setLangState(l);
    try {
      localStorage.setItem("chc_lang", l);
    } catch (e) {
      console.warn("localStorage write failed:", e);
    }
  }, []);
  const t = useCallback((k) => dict[lang]?.[k] ?? dict.en[k] ?? k, [lang]);
  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
